<template>
  <div>
    <div class="dataPng" :style="{backgroundImage:'url('+dataPng+')'}"></div>
    <p>{{message}}</p>
  </div>
</template>

<script>
export default {
  name: "EmptyData",
  data() {
    return {
      dataPng: require("@/assets/images/invoice/nodata.png")
    }
  },
  props: {
    message: {
        type: String,
        default: '暂无数据'
    },    
  },
  components: {},
  created() {
  },
}
</script>

<style scoped>
.dataPng {
  width: 180px;
  height: 180px;
  margin: 30px auto 0;
}
p{
  text-align: center;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
}
</style>
